
import './dynamicTable.css';
import dayjs from 'dayjs';
import { Menu, MenuItem, IconButton, Checkbox, ListItemText } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { useEffect, useState } from 'react';
import PrintIcon from '@mui/icons-material/Print';

import EditIcon from '@mui/icons-material/Edit';
const DynamicTable = ({ data, pageName, selectedValues, handlePrint, showEditButton, tabIndex,
  handleMenuItemClick, handleHeaderClick, handleRowClick, handleBackTable }) => {
  const [menuItems, setMenuItems] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [tableHeaders, setTableHeaders] = useState([]);
  useEffect(() => {
    const sourceData = data && data.length > 0 ? data : '';
    if (sourceData.length > 0) {
      setTableHeaders(Object.keys(sourceData[0]));
    }
  }, [data]);

  const handleMenuOpen = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
    const options = ['Open', 'Close']
    setMenuItems(options);
  }
  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <table className="table-design">
        <thead className="table-header">
          <tr>
            {data && data.length > 0 && (
              <th className="tableBorder" style={{ padding: '8px' }}>S.No</th>
            )}
            {tableHeaders.map((col, index) => {

              if (
                col === 'docEntry' || col === 'DocEntry' || col === "BPLName" ||
                col === 'card_Code' ||
                col === 'Document_Total' ||
                col === 'Remarks' ||
                col === 'leadDetails' ||
                col === 'percentage'
              )
                return null;

              const displayName = col
                .replace(/_/g, ' ')
                .replace(/\b\w/g, (char) => char.toUpperCase());
              return (
                <th
                  key={index}
                  className="tableBorder"
                  style={{ padding: '8px' }}
                  onClick={() => {
                    if (pageName === 'Order History') {
                      handleHeaderClick(col);
                    }
                  }}
                >
                  {displayName}
                  {pageName === 'Order History' && col === 'status' && (
                    <IconButton
                      onClick={handleMenuOpen}
                      style={{
                        position: 'absolute',
                        right: '3px',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        color: 'white',
                        zIndex: 10,
                      }}
                    >
                      <ArrowDropDownIcon />
                    </IconButton>
                  )}

                </th>

              );
            })}
            {pageName === 'Order History' && <th style={{ padding: '8px' }}>Action</th>}
            {/* {pageName === 'Order History' && <th style={{ padding: '8px' }}>S.No</th>} */}
          </tr>
        </thead>
        <tbody className="table-body">
          {pageName !== 'Ledger' && data.length === 0 ? (
            <tr>

              <td
                colSpan={tableHeaders.length + 1}
                style={{
                  textAlign: 'center',
                  padding: '12px',
                  fontStyle: 'italic'
                }}
              >
                No data found
              </td>
            </tr>
          ) : (
            data.map((item, rowIndex) => (
              <tr
                key={rowIndex}
                onClick={() => {
                  if (pageName === 'Order History') {
                    handleRowClick(item);
                  }
                }}
              >
                <td className="tableBorder" style={{ padding: '8px' }}>{rowIndex + 1}</td>
                {Object.entries(item).map(([key, value], cellIndex) => {
                  if (key === 'docEntry' || key === 'DocEntry' || key === "BPLName" ||
                    key === 'card_Code' ||
                    key === 'Document_Total' ||
                    key === 'Remarks' ||
                    key === 'leadDetails' ||
                    key === 'percentage'
                  )
                    return null;

                  if (value === 0 || value === '') {
                    return (
                      <td key={cellIndex} className="table-bodyBorder" style={{ padding: '8px' }}>
                        {value === 0 ? '0' : '-'}
                      </td>
                    );
                  }

                  if (typeof value === 'object') {
                    return (
                      <td key={cellIndex} className="table-bodyBorder" style={{ padding: '8px' }}>
                        {JSON.stringify(value)}
                      </td>
                    );
                  }

                  return (
                    <td key={cellIndex} className="table-bodyBorder" style={{ padding: '8px' }}>
                      {value}
                    </td>
                  );
                })}

                {pageName === 'Order History' && (
                  <td style={{ padding: '8px', textAlign: 'center' }} onClick={(e) => e.stopPropagation()}>
                    <IconButton style={{ color: 'black' }} onClick={() => handlePrint(rowIndex, item)}>
                      <PrintIcon />
                    </IconButton>
                    {tabIndex === 0 && (
                      <IconButton onClick={(e) => { e.stopPropagation(); showEditButton(item); }}>
                        <EditIcon />
                      </IconButton>
                    )}
                  </td>
                )}
              </tr>
            ))
          )}
        </tbody>
        {(pageName === 'SALES QUOTATION HISTORY' || pageName === 'SALES ORDER HISTORY') && (
          <tfoot>
            <tr style={{ borderTop: '1px solid #ccc' }}>
              <td colSpan="9" style={{ textAlign: 'right', fontWeight: 'bold' }}>
                Document Total:
              </td>
              <td style={{ padding: '8px' }}>
                {data?.length > 0 && data[data?.length - 1]?.Document_Total
                  ? data[data?.length - 1].Document_Total
                  : ''}
              </td>
            </tr>
          </tfoot>
        )}
        <Menu className="menu_div" anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
          {menuItems.map((item, index) => (
            <MenuItem
              key={index}
              onClick={() => {
                handleMenuItemClick(item);
                handleMenuClose();
              }}
            >
              <Checkbox checked={selectedValues.includes(item)} />
              <ListItemText primary={`${item}`} />
            </MenuItem>
          ))}
        </Menu>
      </table>
      {/* )} */}

    </>
  );
};

export default DynamicTable;